import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useMatch } from 'react-router-dom';

import { AddKeyPressHandler } from '@gem/keyboard-handler';

import { BlurChat } from 'APP/main/ChatView/BlurChat/BlurChat';
import { ChatUpdateHandler } from 'APP/main/ChatView/ChatUpdateHandler/ChatUpdateHandler';
import { SecretChatAccessRequest } from 'APP/main/ChatView/SecretChatAccessRequest/SecretChatAccessRequest';
import { MainInfoBlock } from 'APP/main/MainInfoBlock/MainInfoBlock';
import { ChatBackground } from 'APP/main/components/ChatBackground/ChatBackground';
import { useChatBackgroundClassName } from 'APP/main/components/ChatBackground/hooks/useChatBackgroundClassName';
import { RouterLink } from 'APP/router/constants';

import { ChannelPopups } from './ChannelPopups/ChannelPopups';
import { ChatDragDrop } from './ChatDragDrop/ChatDragDrop';
import { ChatFooter } from './ChatFooter/ChatFooter';
import { ChatHeader } from './ChatHeader/ChatHeader';
import { useChatViewPresenter } from './ChatView.presenter';
import styles from './ChatView.styles.m.css';
import { MessagePin } from './MessagePin/MessagePin';
import { Messages } from './Messages/Messages';
import { SearchMessages } from './SearchMessages/SearchMessages';
import { UnknownUser } from './UnknownUser/UnknownUser';

export const ChatView: FC = observer(() => {
  const presenter = useChatViewPresenter();
  const isChannel = useMatch(`${RouterLink.Channel}/*`);
  const chatBackgroundClassName = useChatBackgroundClassName();

  if (!presenter.group) {
    return <MainInfoBlock />;
  }

  return (
    <>
      <div
        className={classNames(styles.container, chatBackgroundClassName)}
        data-test="chat"
      >
        <AddKeyPressHandler onEsc={presenter.onClose} />
        <ChatBackground />
        <ChatHeader />
        <UnknownUser groupId={presenter.group.id} />
        <SecretChatAccessRequest groupId={presenter.group.id} />

        <ChatDragDrop
          className={styles.content}
          isAllowDrop={presenter.isAllowPostMessage}
          onDropFiles={presenter.onDropFiles}
        >
          <>
            <MessagePin />
            <Messages
              key={presenter.group.id}
              groupId={presenter.group.id}
            />
            <BlurChat groupId={presenter.group.id} />
          </>
        </ChatDragDrop>

        <ChatFooter isAllowPostMessage={presenter.isAllowPostMessage} />
      </div>
      <ChatUpdateHandler />
      <SearchMessages />
      {isChannel && <ChannelPopups />}
    </>
  );
});
